import { createSelector } from 'reselect';
import { getChannelForWidget } from '@wix/wix-vod-shared/dist/src/common/selectors/channels';
import { isSubscriptionButtonVisible } from 'shared/components/overlay-texts/channel/subscribe-button-text-utils';
import { isSubscribedTo } from '@wix/wix-vod-shared/dist/src/common/ui-selectors/channel/pricing';
export var canShowSubscription = createSelector(getChannelForWidget, function (channel) { return isSubscriptionButtonVisible({ channel: channel }); });
export var canShowCancelSubscription = createSelector(getChannelForWidget, function (channel) { return isSubscribedTo(channel); });
